if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const productRecommendations = this.closest('product-recommendations');
            const refreshRecommendations = () => {
              if (productRecommendations && typeof productRecommendations.loadRecommendations === 'function') {
                productRecommendations.loadRecommendations();
              }
            };
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    refreshRecommendations();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              refreshRecommendations();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  initCustomerLocationLock();
}

function initCustomerLocationLock() {
  const section = document.querySelector('[data-customer-location]');
  if (!section) return;

  const sectionId = section.dataset.section;
  const locationMissing = () => window.BirdApp?.sdk?.selections?.current?.customerLocation == null;

  const roots = () => {
    const sticky = document.querySelector('.sticky-buy-button-wrapper');
    return sticky ? [section, sticky] : [section];
  };

  const sync = () => {
    const missing = locationMissing();
    const state = missing ? 'missing' : 'ready';
    section.dataset.customerLocation = state;
    const sticky = document.querySelector('.sticky-buy-button-wrapper');
    if (sticky) sticky.dataset.customerLocation = state;

    roots().forEach((root) => {
      root.querySelectorAll('quantity-input').forEach((qty) => {
        qty.querySelectorAll('button, input').forEach((el) => {
          if (missing) {
            el.setAttribute('disabled', 'disabled');
            el.dataset.locationLocked = 'true';
          } else if (el.dataset.locationLocked === 'true') {
            el.removeAttribute('disabled');
            delete el.dataset.locationLocked;
          }
        });
        if (!missing && typeof qty.validateQtyRules === 'function') qty.validateQtyRules();
      });

      if (!missing) {
        root.querySelectorAll('.product-form__location-error').forEach((message) => {
          message.hidden = true;
        });
      }

      root.querySelectorAll('.product-form__submit').forEach((button) => {
        if (missing) {
          if (button.dataset.locationLocked !== 'true') {
            button.dataset.locationWasDisabled = button.hasAttribute('disabled') ? 'true' : 'false';
          }
          button.setAttribute('disabled', 'disabled');
          button.dataset.locationLocked = 'true';
        } else if (button.dataset.locationLocked === 'true') {
          if (button.dataset.locationWasDisabled !== 'true') button.removeAttribute('disabled');
          delete button.dataset.locationLocked;
          delete button.dataset.locationWasDisabled;
        }
      });
    });
  };

  const rememberAvailability = (disabled) => {
    roots().forEach((root) => {
      root.querySelectorAll('.product-form__submit').forEach((button) => {
        button.dataset.locationWasDisabled = disabled ? 'true' : 'false';
      });
    });
  };

  section.addEventListener(
    'submit',
    (event) => {
      if (locationMissing()) event.preventDefault();
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!locationMissing()) return;
    if (!event.target.closest('.product-form__quantity, .product-form__buttons')) return;
    const root = event.target.closest('[data-customer-location], .sticky-buy-button-wrapper');
    if (!root) return;
    root.querySelectorAll('.product-form__location-error').forEach((message) => {
      message.hidden = false;
    });
  });

  const onReady = () => {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event?.data || String(event.data.sectionId) !== String(sectionId)) return;
        const updated = event.data.html?.getElementById('ProductSubmitButton-' + sectionId);
        rememberAvailability(!updated || updated.hasAttribute('disabled'));
        sync();
      });
    }

    section.addEventListener('change', () => {
      requestAnimationFrame(() => {
        const button = document.getElementById('ProductSubmitButton-' + sectionId);
        const label = button?.querySelector('span')?.textContent?.trim();
        if (label && window.variantStrings && label === window.variantStrings.unavailable) {
          rememberAvailability(true);
        }
        sync();
      });
    });

    sync();
    setTimeout(sync, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  sync();

  let lastMissing = locationMissing();
  let stickySynced = false;
  setInterval(() => {
    const missing = locationMissing();
    const sticky = document.querySelector('.sticky-buy-button-wrapper');
    const stickyPending = Boolean(sticky) && !stickySynced;
    if (missing === lastMissing && !stickyPending) return;
    lastMissing = missing;
    if (sticky) stickySynced = true;
    sync();
  }, 300);
}